import { Alert, Button, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function ChooseAuthorNoteDialog({ ok, cancel }) {
    return (
        <>
            <DialogTitle>Choose Note to Keep</DialogTitle>
            <DialogContent sx={{ mt: 1.5 }}>
                <Alert severity="info" sx={{ alignItems: "flex-start" }}>
                    <Typography variant="body2">
                        Only one note can be kept. The other will be permanently removed.
                    </Typography>
                </Alert>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Your internal and external author notes are different. Choose which one to keep.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={cancel} variant="text" data-cy="choose-author-note-cancel">
                    Cancel
                </Button>
                <Button
                    onClick={keepInternal}
                    variant="outlined"
                    startIcon={<Iconify icon="mdi:shield-lock-outline" />}
                    data-cy="choose-author-note-internal"
                >
                    Internal
                </Button>
                <Button
                    onClick={keepExternal}
                    variant="contained"
                    startIcon={<Iconify icon="mdi:account-outline" />}
                    data-cy="choose-author-note-external"
                >
                    External
                </Button>
            </DialogActions>
        </>
    )

    function keepInternal() {
        ok("Internal")
    }

    function keepExternal() {
        ok("External")
    }
}
